export default __webpack_public_path__ + "static/media/blog-featured-image-starkware.576e8f04.jpg";